import React, { memo } from "react"
import PropTypes from "prop-types"
import CSlider from "./stencil/cslider-wrapper"
import CText from "./stencil/ctext-wrapper"

const LocationSlider = ({
  children,
  lang,
  dimensions,
  activeSlideIndex,
  radioButtonIdOffset,
}) => {
  const content = require("../data/about.json").locations[lang]

  return (
    <CSlider
      sliderClasses="about-content"
      loadLastSlideItemHalfway={true}
      slides={2}
      collapseOnMobile={true}
      lang={lang}
      path="about"
      activeSlideIndex={activeSlideIndex}
      radioButtonIdOffset={radioButtonIdOffset}
    >
      <div className="carousel-item locations-image-carousel">
        <c-image
          account="schneckenhof"
          alias="senses-integration/about/Shanghai03_ykuupf"
          crop="fill"
          width={dimensions[0]}
          height={
            dimensions[0] < 641
              ? Math.round(dimensions[1] * 0.5)
              : dimensions[1]
          }
        />
        <c-image
          account="schneckenhof"
          alias="senses-integration/about/camilla-bundgaard-7nbP_kHaaGo-unsplash_ditgou"
          crop="fill"
          width={dimensions[0]}
          height={
            dimensions[0] < 641
              ? Math.round(dimensions[1] * 0.5)
              : dimensions[1]
          }
        />
      </div>
      <div className="carousel-item">
        {children}
        <CText
          richText={content}
          maxDesktopText={700}
          maxMobileText={lang === "cn" ? 150 : 250}
          radioButtonIdOffset={21}
          noArrows={dimensions[0] < 641 ? true : false}
          viewport={dimensions[0] < 641 ? "mobile" : "desktop"}
          lang={lang}
        />
      </div>
    </CSlider>
  )
}

LocationSlider.propTypes = {
  children: PropTypes.node,
  dimensions: PropTypes.array,
  lang: PropTypes.string,
  activeSlideIndex: PropTypes.number,
  radioButtonIdOffset: PropTypes.number,
}

export default memo(LocationSlider)
